import React from 'react';

import CommonImage from '@/components/CommonImage';

const FactoryPoOrder = () => {
	return (
		<div className="create-order-container mt-5">
			<div className="payment-and-info-details-table">
				<div className="title mb-12">
					<h3 className="semibold-18">Payment & other info details</h3>
				</div>
				<table className="table with-border no-hover">
					<thead>
						<tr>
							<th>Sub-brand</th>
							<th>Ship Via *</th>
							<th>Payment terms *</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td className="sub-brand-column">Fribbo</td>
							<td className="ship-via-column">
								<div className="option">
									<div className="dropdown rotatable-arrow">
										<button
											className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
											type="button"
											id="menu1"
											data-toggle="dropdown"
											aria-expanded="false"
										>
											Select
											<img src="/icons/down-arrow.png" className="arrow ml-2" alt="" />
										</button>
										<ul
											className="dropdown-menu drdropdown-menu-right shadow-lg"
											role="menu"
											aria-labelledby="menu1"
											x-placement="bottom-end"
										>
											<li role="presentation" className="px-4 pb-3 pt-3">
												<a
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal text-black"
												>
													Air
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<a
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal text-black"
												>
													Courier
												</a>
											</li>
											<li role="presentation" className="px-4 pb-3">
												<a
													role="menuitem"
													tabIndex={-1}
													className="font-weight-normal text-black"
												>
													Ship
												</a>
											</li>
										</ul>
									</div>
								</div>
							</td>
							<td className="payment-terms-column">
								<input type="text" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div className="note-and-destination-qty">
				<table className="table with-border no-hover">
					<thead>
						<tr>
							<th>Important Note</th>
							<th colSpan={2}>Destination wise QTY</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td rowSpan={2} className="note-column">
								<div className="form-group h-100 mb-0">
									<textarea
										type="text"
										className="h-100"
										placeholder="write note"
									></textarea>
								</div>
							</td>
							<td className="destination-column">
								<div className="destination-and-add-btn">
									<div className="form-group">
										<textarea type="text"></textarea>
									</div>
									<div className="add-btn cursor-pointer">
										<CommonImage
											src="/icons/plus_dark_32.svg"
											alt=""
											width={32}
											height={32}
										/>
									</div>
								</div>
							</td>
							<td className="qty-column">
								<input type="text" placeholder="QTY" />
							</td>
						</tr>
						<tr>
							<td className="destination-column">
								<div className="destination-and-add-btn">
									<div className="form-group">
										<textarea></textarea>
									</div>
									<div className="add-btn cursor-pointer">
										<CommonImage
											src="/icons/plus_dark_32.svg"
											alt=""
											width={32}
											height={32}
										/>
									</div>
								</div>
							</td>
							<td className="qty-column">
								<input type="text" placeholder="QTY" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div className="po-all-order-design">
				<div className="header border-0 d-flex justify-content-between">
					<div className="tilte">
						<h3 className="medium-14 mb-0 gray_dark_01">All Designs (20)</h3>
					</div>
					<div className="m-0 search-filter">
						<div className="with-icon right-icon">
							<input type="text" placeholder="Search with design no" defaultValue />
							<span className="right-icon cursor-pointer">
								<img src="/icons/search.png" alt="" />
							</span>
						</div>
					</div>
				</div>
				<div className="order-items">
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
							<div className="check-icon"></div>
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
							<div className="check-icon"></div>
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
							<div className="check-icon"></div>
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
							<div className="check-icon"></div>
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
					<div className="single-design-card">
						<div className="card-top">
							<img src="/images/t-shirt-orange.PNG" alt="" />
						</div>
						<div className="card-content mt-2">
							<h3 className="regular-12 gray_dark_01 design-title">BFb23-Sa-Ba-La-</h3>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FactoryPoOrder;
